import React from "react";
import { ItemPriceBasicSection } from './widgets/ItemPriceBasicSection';
import { GenericSection } from '../sales-order';
import type { ShopifySectionWidgetProps } from './types';

// Export all widgets
export {
  ItemPriceBasicSection,
  GenericSection,
};

// Export widget map
export const ITEM_PRICE_WIDGETS: Record<string, React.ComponentType<ShopifySectionWidgetProps>> = {
  "item-price-basic": ItemPriceBasicSection,
  "item-price-type-validity": GenericSection,
  "item-price-context": GenericSection,
};

// Re-export types
export type { ShopifySectionWidgetProps } from './types';

